import { useMutation, useQueryClient } from '@tanstack/react-query'
import { request } from 'Lib/axios'
import { useUserStore } from 'Stores/userStoreModuleFed'
import { User } from 'Types/User'

const deleteUser = async (user: User) => {
  const accountId = useUserStore.getState().accountId
  const path = user.invitationId ? `invitationId=${user.invitationId}` : `userId=${user.userId}`
  return await request({
    method: 'DELETE',
    url: `accounts/${accountId}/users?${path}`,
  })
}

export const useDeleteUser = () => {
  const queryClient = useQueryClient()
  const { mutate, isLoading, isError, error } = useMutation(deleteUser, {
    onSuccess: () => {
      void queryClient.invalidateQueries(['users'])
    },
  })

  return { mutate, isLoading, isError, error }
}
